(function () {
	const swiperInstances = new Map();

	function addClasses(container) {
		const slides = container.querySelectorAll(".multicolumn-list__item");
		slides.forEach((slide) => {
			slide.classList.add("swiper-slide");
		});
	}

	function initSlider(container) {
		if (!container || swiperInstances.has(container)) return;
		const section = container.closest(".shopify-section") || container.closest(".multicolumn-section");
		const nextEl = section ? section.querySelector(".swiper-button-next") : null;
		const prevEl = section ? section.querySelector(".swiper-button-prev") : null;

		const swiper = new Swiper(container, {
			loop: false,
			initialSlide: 0,
			slidesPerView: 1,
			spaceBetween: 0,
			navigation: {
				nextEl: nextEl,
				prevEl: prevEl,
			},
			on: {
				init: function () {
					this.slideTo(0, 0);
					this.update();
				},
			},
		});
		swiper.slideTo(0, 0);
		swiperInstances.set(container, swiper);
	}

	function destroySlider(container) {
		const swiper = container ? swiperInstances.get(container) : null;
		if (swiper) {
			swiper.destroy(true, true);
			swiperInstances.delete(container);
		}
		const slides = container ? container.querySelectorAll(".multicolumn-list__item") : document.querySelectorAll(".multicolumn-list__item");
		slides.forEach((slide) => {
			slide.removeAttribute("style");
			slide.classList.remove("swiper-slide");
		});
	}

	function initMulticolumn() {
		const sections = document.querySelectorAll(".multicolumn-section");
		sections.forEach((section) => {
			const container = section.querySelector(".swiper--multicolumn");
			if (!container) return;

			const sectionResizeObserver = new ResizeObserver((entries) => {
				const [entry] = entries;
				const width = entry.contentRect.width;

				if (width < 991) {
					addClasses(container);
					initSlider(container);
				} else {
					destroySlider(container);
				}
			});

			sectionResizeObserver.observe(section);

			if (section.offsetWidth < 991) {
				addClasses(container);
				initSlider(container);
			}
		});
	}

	document.querySelectorAll(".swiper--multicolumn").forEach((container) => {
		destroySlider(container);
	});
	initMulticolumn();

	document.addEventListener("shopify:section:load", function () {
		swiperInstances.forEach((_, container) => destroySlider(container));
		initMulticolumn();
	});
})();
